function triggerEditComment() {
 $(document).on("click", ".triggerEditComment", function() {
    $(this)
      .parents(".accountFeedComment")
      .addClass("is-show-editComment");
  });
}